import { Checkbox, Form, Space } from "antd";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Styles } from "./styled";
import {
  getOptionsFormAppPart,
  getRuleValidation,
} from "@lhd/components/CloneApp/fieldUtils";
interface IProps {
  isDisabled?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  namePath: string | string[];
  styleColor?: React.CSSProperties;
  appType?: string;
}

const CheckBox = (props: IProps) => {
  const {
    item,
    isDisabled,
    style,
    namePath,
    preview,
    isTable,
    styleColor = {},
    appType,
  } = props;
  const form = Form.useFormInstance();
  const value = form.getFieldValue(namePath);
  const isShowOnlyValue = !preview && isTable && isDisabled;
  const options = getOptionsFormAppPart(item, appType);
  return (
    <Styles
      style={{ ...styleColor, ...style }}
      id={item.id}
      className="check-box"
      color={styleColor?.color}
      background={styleColor?.background}
    >
      <div className="value_text_container">{isShowOnlyValue && value}</div>
      <Form.Item
        hidden={isShowOnlyValue}
        name={namePath}
        rules={getRuleValidation(item)}
      >
        <Checkbox.Group>
          <Space
            direction={(item.item_config_data?.layout as any) || "horizontal"}
          >
            {options.map((option, i) => {
              return (
                <Checkbox key={i} value={option.label}>
                  {option.label}
                </Checkbox>
              );
            })}
          </Space>
        </Checkbox.Group>
      </Form.Item>
    </Styles>
  );
};
export default CheckBox;
